export const buildShortProductImageUrl = (value) => {
    if (!value) {
        return '';
    }

    if (/^https?:\/\//i.test(value)) {
        return value;
    }

    const liveBase = typeof window !== 'undefined'
        ? (window.live || window.location.origin).replace(/\/$/, '')
        : '';
    const path = value.startsWith('/') ? value : `/${value}`;

    return `${liveBase}${path}`;
};

export const parseShortProductImages = (images) => {
    let imageList = images;

    if (typeof imageList === 'string') {
        try {
            imageList = JSON.parse(imageList);
        } catch (error) {
            imageList = [];
        }
    }

    if (!Array.isArray(imageList)) {
        return [];
    }

    return imageList
        .map((item) => {
            if (typeof item === 'string') {
                return item;
            }

            return item?.url || item?.path || item?.image_url || item?.thumbUrl || item?.thumb_url || '';
        })
        .filter(Boolean);
};
